/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Description_Export_Video_FailedInputs */



/**
* | output |
* | --- |
* | "Error exporting video: {error}" |
*
* @param {Audio_Description_Export_Video_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_video_failed = /** @type {((inputs: Audio_Description_Export_Video_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Video_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors de l'exportation vidéo : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Videoexport: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante l'esportazione del video: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка экспорта видео: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al exportar el vídeo: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导出视频时出错：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ビデオのエクスポート中にエラーが発生しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`वीडियो निर्यात करने में त्रुटि: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao exportar o vídeo: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error exporting video: ${i?.error}`)
});